import { Anchor, AspectRatio, Stack, Text } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { NavBarContainer } from "./NavBarContainer";

export function Tutoriales() {
  const { t } = useTranslation();

  return (
    <NavBarContainer title={t("tutorials.title")}>
      <Stack gap="md">
        <Text>
          {t("tutorials.alsoSeeFaqBefore")}{" "}
          <Anchor component={Link} to="/faq">
            {t("tutorials.alsoSeeFaqLink")}
          </Anchor>
        </Text>
        <Text>{t("tutorials.sendLicenseTutorial")}</Text>
        <AspectRatio ratio={16 / 9} maw={600}>
          <iframe
            title={t("tutorials.iframeTitle")}
            src="https://www.youtube.com/embed/FF3ZZ6gjJLE"
            allowFullScreen
          />
        </AspectRatio>
      </Stack>
    </NavBarContainer>
  );
}
